import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 30000 });

export async function fetchProgress(sessionId) {
  const { data } = await api.get(`/progress/${sessionId}`);
  return data;
}

export async function saveProgress(payload) {
  const { data } = await api.post(`/progress`, payload);
  return data;
}

export async function evaluatePrompt(payload) {
  const { data } = await api.post(`/evaluate`, payload);
  return data;
}

export async function fetchLeaderboard() {
  const { data } = await api.get(`/leaderboard`);
  return data;
}
